;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"b676981072add78738be5ff2a8e159906900108c"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

if (process.env.NODE_ENV === "production") {
Sentry.init({
  dsn: "https://18f9c5b830989557dd810f4e6bdadeba@o4508006562004992.ingest.de.sentry.io/4508019388710992",
  environment: process.env.NEXT_PUBLIC_SENTRY_ENV || "production",
  denyUrls: [
    /@next\/third-parties\/dist\/google\/gtm\.js/i, // Next 3P GTM bundle
    /googletagmanager\.com/i,
    /gtm\.js/i,
    /google-analytics\.com/i,
  ],
  // Fast drop: known harmless error messages (browser-y network noise)
  ignoreErrors: [
    /TypeError:\s*Load failed/i,
    /Load failed/i,
    /NetworkError/i,
    /Failed to fetch/i,
  ],

  beforeSend(event: any) {
    // If there are exception values, inspect frames
    const values = event.exception?.values ?? [];
    const frames = values.flatMap((v: any) => v.stacktrace?.frames ?? []);
    const hasInApp = frames.some((f: any) => f.in_app === true);

    // Some Next.js internal noise: occasionally shows up as an error message
    const msg = event.message || values.map((v: any) => v.value).join(" | ");

    if (/incomplete-app-router-transaction/i.test(msg)) return null;

    if (!hasInApp) return null;       // drop purely non-app stacks
    return event;
  },

  // Drop noisy performance transactions from the App Router
  beforeSendTransaction(event: any) {
    if (event.transaction === "incomplete-app-router-transaction") {
      console.info("[Sentry] Dropped TX via beforeSendTransaction:", event.transaction);
      return null;
    }
    return event;
  },

  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.01, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 0.1,

  release: "offerz-nextjs@1.0.1",

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: true,
});
}
